import { FC } from 'react'
import { Box } from '@mui/material'

/* Utils */
import { CategoryActivityItem } from '../../../../models'

/* Components */
import StubPerformanceScore from './DashboardLoading/components/StubPerformanceScore'
import OverallPerformanceScore from './OverallPerformanceScore/OverallPerformanceScore'
import InsightsWidget from './InsightsWidget'

interface Props {
  performanceScore: number
  categories: CategoryActivityItem[]
}

const DashboardHeroEmpty: FC<Props> = ({ performanceScore, categories }) => (
  <Box className="performance-score-section">
    <OverallPerformanceScore performanceScore={performanceScore} categories={categories} />
    <StubPerformanceScore />
    <InsightsWidget unreadInsightsCount={0} insightsCountLoading={false} insightsData={null} />
  </Box>
)

export default DashboardHeroEmpty
